import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "@docma-mm-core/config/config.service";
import { BasedataService } from "@docma-mm-core/shared/basedata.service";
import { catchError } from "rxjs";
import { Observable } from "rxjs/internal/Observable";
import { GroupData } from "./group";

@Injectable()
export class GroupApiService extends BasedataService {

    private readonly projectsUrl = '/projects/';
    private readonly groupsUrl = '/groups/';

    constructor(private http: HttpClient, configService: ConfigService) {
        super(configService);
    }

    // create new group
    createGroup(project: {mydocmaUid: string, projectId: number}, group: GroupData): Observable<GroupData> {
    const endpoint = super.getFullUrl(this.projectsUrl + project.projectId + this.groupsUrl);
    return this.http
    .post<GroupData>(endpoint, JSON.stringify(group), { headers: this.getHeaders() })
    .pipe(catchError(e  => this.handleError(e)));
    }

}
